import { LintSeverity } from '@scale/shared/task_lint/task_linter';
import type { LintMessage } from './LintMessage';

export function getCanSubmit(lintMessages: LintMessage[]) {
  const noBlockingLintMessages =
    lintMessages.filter(lintMessage => lintMessage.severity === LintSeverity.ERROR).length === 0;
  const noUnresolvedLintMessages =
    lintMessages.filter(
      lintMessage =>
        [LintSeverity.WARNING, LintSeverity.DISMISSABLE_ERROR, LintSeverity.INFO].includes(
          lintMessage.severity,
        ) && !lintMessage.dismissed,
    ).length === 0;

  const passLinters = noBlockingLintMessages && noUnresolvedLintMessages;
  const allLinterFeedbackCompleted =
    lintMessages.filter(lintMessage => lintMessage.forceLinterFeedback && !lintMessage.feedback)
      .length === 0;
  return {
    canSubmit: passLinters && allLinterFeedbackCompleted,
    passLinters,
    allLinterFeedbackCompleted,
  };
}
